let id = 0;
function getUid() {
    return `${id++}`;
}

export { getUid };
